import phase013 from 'asset/pet/preview/phase-013.png';
import phase013b from 'asset/pet/preview/phase-013-b.png';
import phase014 from 'asset/pet/preview/phase-014.png';
import phase014b from 'asset/pet/preview/phase-014-b.png';
import phase015 from 'asset/pet/preview/phase-015.png';
import phase015b from 'asset/pet/preview/phase-015-b.png';
import phase016 from 'asset/pet/preview/phase-016.png';
import phase016b from 'asset/pet/preview/phase-016-b.png';
import feed012Thanks from 'asset/pet/preview/feed-012-thanks.gif';
import pet013Gif from 'asset/pet/preview/pet-013.gif';
import feed013Gif from 'asset/pet/preview/feed-013.gif';
import petBk013 from 'asset/pet/preview/pet-bk-013.jpg';
import { OssOther } from 'utils/const.js';

export const MAX_PET_PHASE = 16;
export const HUNGRY_DISABLED_PHASE = 12;

const previewPhaseAssets = {
  13: phase013,
  14: phase014,
  15: phase015,
  16: phase016,
};

const previewPetIdleGifs = {
  13: pet013Gif,
};

const previewPetFeedGifs = {
  13: feed013Gif,
};

const previewPetBackgrounds = {
  13: petBk013,
};

export const PET_PHASE_RECORDS = [
  { name: '幼年悟空', src_b: OssOther + '/image/pet-oss/pet-01.png', src: OssOther + '/image/pet-oss/pet-01.png', visible: true },
  { name: '顽童悟空', src_b: OssOther + '/image/pet-oss/pet-02-b.jpg', src: OssOther + '/image/pet-oss/pet-02.png', visible: true },
  { name: '少年悟空', src_b: OssOther + '/image/pet-oss/pet-03-b.jpg', src: OssOther + '/image/pet-oss/pet-03.png', visible: true },
  { name: '修行悟空', src_b: OssOther + '/image/pet-oss/pet-04-b.jpg', src: OssOther + '/image/pet-oss/pet-4.png', visible: true },
  { name: '觉醒悟空', src_b: OssOther + '/image/pet-oss/pet-06-b.jpg', src: OssOther + '/image/pet-oss/pet-05.png', visible: true },
  { name: '传奇悟空', src_b: OssOther + '/image/pet-oss/pet-05-b.jpg', src: OssOther + '/image/pet-oss/pet-06.png', visible: true },
  { name: '斗战胜佛', src_b: OssOther + '/image/pet-oss/pet-07-b.jpg', src: OssOther + '/image/pet-oss/pet-07.png', visible: true },
  { name: '混元斗圣', src_b: OssOther + '/image/pet-oss/pet-08-b.jpg', src: OssOther + '/image/pet-oss/pet-08.png', visible: true },
  { name: '涅槃真圣', src_b: OssOther + '/image/pet-oss/pet-09-b.png', src: OssOther + '/image/pet-oss/pet-09.png', visible: true },
  { name: '返老还童', src_b: OssOther + '/image/pet-oss/pet-010-b.png', src: OssOther + '/image/pet-oss/pet-010.png', visible: true },
  { name: '太乙佛尊', src_b: OssOther + '/image/pet-oss/pet-011-b.png', src: OssOther + '/image/pet-oss/pet-011.png', visible: true },
  { name: '齐天大圣', src_b: OssOther + '/image/pet-oss/pet-012-b.png', src: OssOther + '/image/pet-oss/pet-012.png', visible: true },
  { name: '赛博大圣', src_b: phase013b, src: phase013, visible: true },
  { name: '火眼神尊', src_b: phase014b, src: phase014, visible: true },
  { name: '三界圣尊', src_b: phase015b, src: phase015, visible: true },
  { name: '凌霄圣帝', src_b: phase016b, src: phase016, visible: true },
];

export const isMaxPetPhase = (phase) => Number(phase) >= MAX_PET_PHASE;

export const isHungryDisabledPhase = (phase) => Number(phase) >= HUNGRY_DISABLED_PHASE;

export const getPetAvatarSrc = (phase) => {
  const p = Number(phase) || 1;
  return PET_PHASE_RECORDS[p - 1]?.src || PET_PHASE_RECORDS[0].src;
};

export const getPetIdleSrc = (phase) => {
  const p = Number(phase) || 1;
  if (previewPetIdleGifs[p]) return previewPetIdleGifs[p];
  return previewPhaseAssets[p] || OssOther + `/image/pet-oss/pet-0${p}.gif`;
};

export const getPetFeedSrc = (phase) => {
  const p = Number(phase) || 1;
  if (p === 12) return feed012Thanks;
  if (previewPetFeedGifs[p]) return previewPetFeedGifs[p];
  return previewPhaseAssets[p] || OssOther + `/image/pet-oss/feed-0${p}.gif`;
};

export const getPetBackgroundSrc = (phase) => {
  const p = Number(phase) || 1;
  if (previewPetBackgrounds[p]) return previewPetBackgrounds[p];
  const bgPhase = p > 12 ? 12 : p;
  return OssOther + `/image/pet-oss/pet-bk-0${bgPhase}.jpg`;
};

export const normalizeGardenInfoForPetPreview = (gardenInfo) => {
  if (!gardenInfo?.PetInfo) return gardenInfo;

  const next = {
    ...gardenInfo,
    PetInfo: { ...gardenInfo.PetInfo },
  };

  let previewPhase = 0;
  try {
    const url = new URL(window.location.href);
    previewPhase = Number(url.searchParams.get('previewPhase') || 0);
  } catch (e) {
    previewPhase = 0;
  }

  if (Number.isInteger(previewPhase) && previewPhase >= 1 && previewPhase <= MAX_PET_PHASE) {
    const min = (previewPhase - 1) * 100;
    next.PetInfo.Phase = previewPhase;
    next.PetInfo.Min = min;
    next.PetInfo.Max = previewPhase >= MAX_PET_PHASE ? min : min + 100;
    next.rela_energy_used = previewPhase >= MAX_PET_PHASE ? 0 : 35;
    next.energy_used = min + next.rela_energy_used;
    return next;
  }

  const phase = Number(next.PetInfo.Phase);
  const min = Number(next.PetInfo.Min) || 0;
  const max = Number(next.PetInfo.Max) || 0;
  if (phase === 12 && max <= min) {
    next.PetInfo.Max = min + 100;
    next.rela_energy_used = Math.min(Number(next.rela_energy_used) || 0, 99);
  }

  return next;
};
